<template>
  <b-form-group
    :label="inline ? undefined : label"
    :label-class="{ required }"
    :invalid-feedback="error"
    :state="error ? false : null">
    <boolean-input-field
      v-bind="$props"
      @input="$emit('input', $event)"
    />
  </b-form-group>
</template>
<script>
import FormFieldMixin from 'vue-forms/mixins/FormFieldMixin';
import BooleanFieldMixin from 'vue-forms/mixins/BooleanFieldMixin';

export default {
  mixins: [ FormFieldMixin, BooleanFieldMixin ],
};
</script>
